import React from 'react';
import { useUser } from '@clerk/clerk-react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useStelline } from '../contexts/StellineContext';
import { useGlobalModal } from '../contexts/ModalContext';
import useHasEverAuthenticated from '../hooks/useHasEverAuthenticated';
import { buildTrackedAuthRedirectUrl } from '../analytics';
import Button from './Button';
import FaIcon from './FaIcon';
import styles from '../styles/StellineInfoModal.module.css';
import modalStyles from '../styles/modal.module.css';
import buttonStyles from '../styles/Button.module.css';
import { GOOGLE_INTERSTITIAL_INELIGIBLE_ATTRIBUTES } from '../ads/googleInterstitialAttributes';

const StellineInfoModal = () => {
  const { isSignedIn } = useUser();
  const hasEverAuthenticated = useHasEverAuthenticated();
  const { stellineBalance } = useStelline();
  const navigate = useNavigate();
  const location = useLocation();
  const { closeModal } = useGlobalModal();

  const displayBalance = isSignedIn ? Math.max(0, Number(stellineBalance) || 0) : 0;

  const handleAuthClick = () => {
    closeModal();
    const currentPath = location.pathname + location.search;
    const message = hasEverAuthenticated
      ? 'Accedi al tuo account per iniziare a ottenere stelline.'
      : 'Crea un account gratuito per iniziare a ottenere stelline.';
    const authUrl = buildTrackedAuthRedirectUrl({
      cta_kind: hasEverAuthenticated ? 'sign_in' : 'sign_up',
      source_surface: 'stelline_info_modal',
      gate_reason: 'stelline_requires_auth',
      next_path: currentPath,
      message,
      is_returning_device: hasEverAuthenticated,
      track_gate_viewed: true,
      trigger: 'modal_auth_cta',
    });
    navigate(authUrl);
  };

  return (
    <div className={modalStyles.modalContent}>
      <div className={styles.content}>
        <p className={styles.description}>
          Le stelline premiano la tua abilità nei giochi. Si ottengono giocando e non si possono spendere.
        </p>

        <div className={styles.balanceDisplay}>
          <span className={styles.balanceNumber}>{displayBalance.toLocaleString('it-IT')}</span>
          <span className={styles.balanceIcon} aria-hidden="true">
            <FaIcon className="fa-solid fa-star" />
          </span>
        </div>

        <p className={styles.description}>
          Il valore mostrato include le stelline ottenute questa settimana,
          a partire da domenica alle 00:00 UTC.
        </p>

        {!isSignedIn && (
          <>
            <p className={styles.description}>
              Accedi per salvare le tue stelline su tutti i dispositivi.
            </p>
            <Button
              primary
              className={`${styles.joinButton} ${buttonStyles.primaryBlue} ${buttonStyles.inline}`}
              onClick={handleAuthClick}
            >
              {hasEverAuthenticated ? 'Accedi al tuo account' : 'Inizia a ottenere stelline'}
            </Button>
          </>
        )}

        <div className={styles.learnMoreLink}>
          <Link to="/stelline" onClick={closeModal} {...GOOGLE_INTERSTITIAL_INELIGIBLE_ATTRIBUTES}>
            Scopri di più sulle stelline →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default StellineInfoModal;
